import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-017d7a1b")

_pushScopeId("data-v-017d7a1b")
const _hoisted_1 = { class: "Tabs" }
const _hoisted_2 = {
  key: 0,
  class: "Tabs__content"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["Tabs__title", _ctx.classes],
      style: _ctx.type === _ctx.TabType.HORIZONTAL_SCROLL && _ctx.style
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: `item-${index}`,
          class: ["Tabs__title-item", [{ 'Tabs__title-item--active': _ctx.selectedIndex === index }]],
          onClick: _withModifiers($event => (_ctx.tabClick(index)), ["stop"])
        }, _toDisplayString(item.name), 11, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 6),
    (_ctx.$slots.contents)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "contents")
        ]))
      : _createCommentVNode("", true)
  ]))
})